/* eslint-disable react/destructuring-assignment */
import React, { CSSProperties } from 'react';
import styled from 'styled-components';

const IconContainerStyled = styled.div`
  height: 100%;
  position: relative;
`;
const IconComponent: React.FC<
  { name: string; className?: string; size?: number; color?: string; style?: CSSProperties } & Partial<
    React.DOMAttributes<HTMLDivElement>
  >
> = ({ name, className, size = 18, color = '#8c8c8c ', style, ...props }) => {
  const iconClassName = name.includes('icon icon-') ? name : `icon icon-${name}`;
  return (
    <IconContainerStyled
      {...props}
      className={className}
      style={{ minWidth: size, lineHeight: 0.75, cursor: props?.onClick ? 'pointer' : undefined }}>
      <div className={iconClassName} style={{ fontSize: size, color, height: size, ...style }} />
    </IconContainerStyled>
  );
};

export default React.memo(IconComponent);
